import React from 'react';
import { toast } from 'react-toastify';
import { HINDSIGHTING } from 'src/utils/Domain/Constants';

import { RestoreSessionState, RestoreSessionProps } from './RestoreSession.container';
import { getSessionAll } from './RestoreSession.utils';
import { Perspective } from 'configuration-schemas/bindings.types';
import {
  getPerspectiveConfig,
  PerspectiveConfig,
  isPerspective,
  isEnabledPerspective,
} from 'src/pages/PerspectiveSelection/PerspectiveSelection';
import ServiceContainer from 'src/ServiceContainer';
import './RestoreSession.scss';
import { getPerspectiveLookupKey } from 'src/services/configuration/service';

class RestoreSession extends React.Component<RestoreSessionProps, RestoreSessionState> {
  state = {
    loading: false,
  };

  applyNav = async (perspective: Perspective, activeTab: string, perspectiveConfig: PerspectiveConfig) => {
    const groups = perspectiveConfig.view.filter(isPerspective);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const perspectiveBinding = groups.find((x) => {
      const perspectiveLookupKey = getPerspectiveLookupKey(x);
      return perspectiveLookupKey == perspective;
    })!;

    if (isEnabledPerspective(perspectiveBinding)) {
      this.props.setPerspective(perspectiveBinding);
      this.props.setActiveTab(activeTab);
    }
  };

  applySession = async (
    perspective: Perspective,
    tab: string | null,
  ) => {
    const config = await getPerspectiveConfig().then((x) => x.data);
    await this.applyNav(perspective, tab || HINDSIGHTING, config);
  };

  onClick = () => {
    const {
      tab,
      perspective,
      page,
    } = getSessionAll();

    if (!perspective) return;

    this.setState({
      loading: true,
    });
    toast.dismiss('restoreSession');

    this.applySession(perspective, tab)
      .then(() => {
        if (page) {
          this.props.routerNavigate(page);
        }
      })
      .catch((e) => {
        ServiceContainer.loggingService.error('Error: Unable to restore previous session', e);
        this.destroy();
        toast.error('Error: Unable to restore previous session.', {
          position: toast.POSITION.TOP_LEFT,
        });
      });
  };

  destroy() {
    toast.dismiss('restoreSession');
    this.setState({ loading: false });
  }

  componentDidMount() {
    toast(
      <div onClick={this.onClick} className="restore-session-message">
        <p>Click here to pick up where you left off! </p>
      </div>,
      {
        position: toast.POSITION.TOP_LEFT,
        closeOnClick: false,
        autoClose: false,
        draggable: false,
        type: 'info',
        toastId: 'restoreSession',
      }
    );
  }

  componentWillUnmount() {
    this.destroy();
  }

  render() {
    return <React.Fragment />;
  }
}
export default RestoreSession;
